<template>
  <div class="element-search">
    <div class="element-wrapper">
      <input v-model="searchText" @keypress.enter="search" :placeholder="placeholder"/>
      <span @click="search"><img :src="'../static/search.png'"></span>
    </div>
    <element-autocomplete v-if="autocomplete.status" @clickItem="selectedItem" :items="autocomplete.results" />
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<style lang="scss" scoped>
  .element-search {
    .error {
      margin-top: 0.5rem;
      color: #cc3232;
    }
  }
</style>

<script>
import moment from 'moment'

export default {
  props: [ "placeholder", "type", "insur_startdate" ],
  data(){
    return {
      searchText: '',
      autocomplete: {
        items: [],
        results: [],
        status: false,
      },
      st: null,
      api_prm_year: null,
      api_prm_quarter: null,
      error: "",
    }
  },
  created() {
    this.api_prm_year = moment(this.insur_startdate).year()
    this.api_prm_quarter = moment(this.insur_startdate).quarter()
  },
  methods: {
    selectedItem: function ( item ) {
      this.searchText = item.value.value;
      this.autocomplete.status = false;

      var index = this.autocomplete.results.findIndex(o => o.value === this.searchText);
      
      this.$emit("searchComplete", this.autocomplete.items[index]);
    },
    init(){
      this.autocomplete.items = [];
      this.autocomplete.results = [];
    },
    search(evt) {
      this.init();
      if(this.searchText.length < 1){
        this.error = "1글자 이상 입력하셔야 합니다.";
        return;
      }
      if(this.searchText && this.searchText.length >= 1){
          
        this.$store.dispatch( "estimate/search", { 
          search_auto_type: this.type,
          searchText: this.searchText,
          search_table_year: this.api_prm_year,
          search_table_quarter: this.api_prm_quarter,
        }).then( res => {
          var items = res.data.data.items;
          var tmp = [];
          if( res.data.data.total == 0){
            this.error = "조회된 차량모델이 없습니다.";
          }else{
            this.error = "";
            items.forEach( item => {
              let entries = Object.entries( item );
              let checker = entries.filter( o => {  
                // 차량가액 필터링 0 인 경우 제외
                let checkString = o[0].substring( 0, 4 );
                return o[1] > 0 && checkString * 1 == checkString;
              });
              checker.forEach( year => {
                let clone = Object.assign({}, item, { "등록연도": year[0] });
                tmp.push( clone );
              });
            });

            // this.autocomplete.items = res.data.data.items;
            
            this.autocomplete.items = tmp;

            if(this.autocomplete.items.length > 0){
              this.autocomplete.status = true;

              this.autocomplete.items.forEach( o => {
                var result_item = [o.제조사, o.공통차명, o.등록연도, o.차명, o.세분].join(", ").toUpperCase();
                var spls = result_item.split(this.searchText.toUpperCase());

                var price_option_item = o[o.등록연도];
              
                this.autocomplete.results.push(
                  { value: result_item, searchText: this.searchText ,splited_texts: spls, optional_text: price_option_item }
                );
              })
            }
            else {
              this.autocomplete.status = false;
            }
          }
        });
      }
    }

  }
}
</script>
